import { render } from "./HeaderApp.vue?vue&type=template&id=3ff60f35&scoped=true"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"

import "@/assets/css/Header.css?vue&type=style&index=0&id=3ff60f35&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff60f35"]])

export default __exports__